import { ContextMenuItem } from './context-menu.types'

export enum SHORTHANDS {
  EXPORT = 'excelExport',
  SEPARATOR = 'separator',
  IDENTIFIER = 'rowIdentifier',
}

export const SHORTHAND_ITEMS: ReadonlyArray<SHORTHANDS> = [
  SHORTHANDS.EXPORT,
  SHORTHANDS.SEPARATOR,
  SHORTHANDS.IDENTIFIER,
]

export const CONTEXT_MENU_ERROR =
  'LKGrid: "getContextMenuItems" prop returned something wrong (check acceptable values).'

export const DefaultContextMenuItemOrder: ReadonlyArray<ContextMenuItem> = [
  {
    type: 'title',
    order: 0,
  },
  {
    type: 'info',
    order: 1,
  },
  {
    type: 'edit',
    order: 2,
  },
  {
    type: 'delete',
    order: 3,
  },
  {
    type: 'visa_operations',
    order: 3,
  },
  {
    type: 'history',
    order: 4,
  },
  {
    type: 'print',
    order: 5,
  },
  {
    type: 'excel',
    order: 6,
  },
  {
    type: 'copy',
    order: 7,
  },
]
